<app-loader *ngIf="loader"></app-loader>
<section>
    <app-navbar></app-navbar>
    <div class="container-fluid">
        <h4 class="text_color mt-4 mb-0">
            Where‘s my <br />
            money going?
        </h4>
        <div class="row d-flex justify-content-end">
            <span class="selected_meter font-weight-bold">
                Device : {{ selected_meter_id }}
            </span>
            <!-- <span class="font-weight-bold selected_meter">Device 01 </span> -->
        </div>
        <div class="mb-3 mt-3 d-flex justify-content-between">
            <button class="btn top_btn" (click)="getYesterday()" [ngClass]="{ active: clicked === true }"
                data-toggle="tab" (click)="clicked= true; clicked1= false; clicked2= false">
                Day
            </button>
            <button class="btn top_btn" (click)="getLast7days()" [ngClass]="{ active: clicked1 === true }"
                data-toggle="tab" (click)="clicked= false; clicked1= true; clicked2= false">
                Week
            </button>
            <button class="btn top_btn" (click)="getLast30days()" [ngClass]="{ active: clicked2 === true }"
                data-toggle="tab" (click)="clicked= false; clicked1= false; clicked2= true">
                Month
            </button>
            <button class="btn top_btn" disabled>Year</button>
        </div>

        <div class="row mt-3">
            <div class="col-md-12 col-sm-12 col-xs-12">
                <app-top-usage-bar [consumption]="stackdata" [uptime]="uptimePercentage" id="stackdata">
                </app-top-usage-bar>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12 col-sm-12 col-xs-12 p-0">
                <app-stackedbar [consumption]="stackdata" id="stackdata"></app-stackedbar>
            </div>
        </div>
        <div class="row mt-3 mb-5">
            <div class="col-12">
                <div class="card">
                    <div class="card-body p-3">
                        <h6 class="text-danger font-weight-bold">Appliance
                            Activity</h6>
                        <div class="row">
                            <div class="col-12">
                                <div class="accordion" [attr.id]="'accordion_' + i" *ngFor="let usage of applianceUsage; let i=
                                    index">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="card-head" id="headingTwo">
                                                <h2 class="mb-0 collapsed
                                                    font-weight-bold indent" data-toggle="collapse" [attr.data-parent]="'#accordion_'
                                                    + i" [attr.href]="'#collapseOne_'
                                                    + i">
                                                    {{ usage.appliance }}
                                                    <br />
                                                    {{ usage.start | date:
                                                    "medium" }}
                                                </h2>
                                            </div>
                                            <hr />
                                            <div [attr.id]="'collapseOne_' + i" class="collapse" [ngClass]="{ show: dashboard_id
                                                == usage._id }">
                                                <div class="card-body p-0">
                                                    <div class="row details">
                                                        <div class="col-12">
                                                            <h5 class="text-center
                                                                text-danger">
                                                                You know, I’ll
                                                                get smarter with
                                                                time
                                                            </h5>
                                                        </div>
                                                        <div class="col-12 d-flex
                                                            mt-2" style="justify-content:
                                                            space-evenly">
                                                            <button class="btn
                                                                usage_btn" (click)="wrongDetection(usage._id)"
                                                                [disabled]="usage.answered
                                                                === true">
                                                                Wrong Detection
                                                            </button>
                                                            <button class="btn
                                                                usage_btn" (click)="noThanks(usage._id)">
                                                                No Thank's
                                                            </button>
                                                            <!-- <button class="btn usage_btn" data-toggle="modal" data-target="#applianceListModel" (click)="tagAppliance(usage._id)">Tag an
                                                                appliance</button> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="col-6">
                <div class="card ohm_tip">
                    <div class="card-body p-3">
                        <h6 class="text-light font-weight-bold">Ohm Tip!</h6>
                        <p class="mb-5">Coming Soon !</p>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</section>

<app-bottom-navbar></app-bottom-navbar>

<!-- Appliance Modal -->
<div class="modal fade" id="applianceListModel" tabindex="-1" role="dialog" aria-labelledby="applianceListModelLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Appliance List</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-4" *ngFor="let list of appliance">
                        <div class="card">
                            <div class="card-body p-2">
                                <div class="top_details" (click)="tagComplete(list._id)" data-dismiss="modal">
                                    <!-- <img src="../../../assets/img/ac.svg" alt="ac" class="img-fluid device_img"> -->
                                    <img src="../../../assets/img/ac.svg" alt="ac" class="img-fluid device_img"
                                        *ngIf="list.applianceName == 'AC'" />
                                    <img src="../../../assets/img/geyser.svg" alt="ac" class="img-fluid device_img"
                                        *ngIf="list.applianceName == 'GEYSER'" />
                                    <img src="../../../assets/img/washing_machine.svg" alt="ac"
                                        class="img-fluid device_img" *ngIf="list.applianceName == 'WM'" />
                                    <h6 class="font-weight-bold text-danger">
                                        {{ list.applianceNickname }}
                                    </h6>
                                    <p class="mb-0">{{ list.applianceModelNo }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>